const ENIndicatorsPresentationPanel = {
	"Apresentação de indicadores": "Indicators presentation",
	"Selecione um grupo de apresentação ao lado": "Select a presentation group on the side"
};

export default ENIndicatorsPresentationPanel;
